export default __webpack_public_path__ + "static/media/vpn-green.82ee8452.svg";